import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useState } from "react";
import Button from "src/components/ui/Button";
import Pagination from "src/components/ui/Pagination";

interface CardListProps {
  data?: Array<Record<string, any>>;
  pagination?: {
    totalDocs: number;
    totalPages: number;
    currentPage: number;
    pageLimit: number;
    hasNextPage: number;
    hasPrevPage: number;
  } | null;
  className?: string;
  onPageChange?: (page: number) => void;
  titleComponent: (props: any) => any;
  bodyComponent?: (props: any) => any;
}

const CardList: React.FC<CardListProps> = ({
  data = [],
  pagination,
  onPageChange,
  titleComponent,
  bodyComponent,
  className = "",
}) => {
  const [activeCardIndex, setActiveCardIndex] = useState(-1);
  return (
    <div className={className}>
      <div className="border border-gray-200 rounded-lg">
        {data?.map((row, index) => {
          const isActive = activeCardIndex === index;
          return (
            <div className="border-b border-gray-200 last:border-none">
              {/* title */}
              <div className="relative p-4">
                <div>{titleComponent(row)}</div>

                <Button
                  className="absolute top-4 right-4"
                  variant="ghost"
                  rounded="full"
                  size="sm"
                  onClick={() =>
                    setActiveCardIndex(index !== activeCardIndex ? index : -1)
                  }
                >
                  {activeCardIndex !== index ? (
                    <ChevronDown size={18} height={28} />
                  ) : (
                    <ChevronUp size={18} height={28} />
                  )}
                </Button>
              </div>

              {/* body */}
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  isActive
                    ? "max-h-[800px] opacity-100"
                    : "max-h-0 opacity-0 pointer-events-none"
                }`}
              >
                <div className="p-4 bg-gray-50">{bodyComponent?.(row)}</div>
              </div>
            </div>
          );
        })}
      </div>

      {pagination && (
        <Pagination
          currentPage={pagination.currentPage}
          pageLimit={pagination.pageLimit}
          totalPages={pagination.totalPages}
          totalRecords={pagination.totalDocs}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default CardList;
